<template>
    <div v-if="isShow" class="guide-card">
        <div class="icon"></div>
        <div class="title">
            您有<span>几项</span>认证信息待补充
        </div>
        <div class="sub-title">
            完整资料获取更多优质安源！
        </div>
        <veui-button
            class="btn"
            @click="jumpMaterial"
        >立即完善</veui-button>
    </div>
</template>

<script>
import {Button} from 'veui';
import {mapState} from 'vuex';
export default {
    name: 'authention-guide-card',
    components: {
        'veui-button': Button
    },
    computed: {
        ...mapState({
            userInfo: state => state?.lawStore?.userInfoNew,
            authenticationStatus: state => state?.lawStore?.authenticationStatus
        }),
        isShow() {
            // 认证成功过，律师职务和职业理念未填写则展示
            return this.authenticationStatus === 7 && this.userInfo?.first_approve === 1 && (!this.userInfo?.lawyer_info?.register_philosophy
                || !this.userInfo?.lawyer_info?.lawyer_position);
        }
    },
    methods: {
        // 跳转我的认证
        jumpMaterial() {
            if (this.$route.name === 'material') {
                this.$emit('clickEdit');
                return;
            }
            this.$router.push({
                name: 'material',
                query: {
                    isEdit: 'edit',
                    editAnchor: 'personal-info'
                }
            });
        }
    }
};
</script>

<style lang='less' scoped>
.guide-card {
    height: 100px;
    border-radius: 8px;
    margin-top: 24px;
    position: relative;
    border: 1.5px solid #fff;
    background: linear-gradient(270.14deg, #fff 62.84%, #e7f9ff 99.88%);

    .icon {
        width: 110px;
        height: 86px;
        position: absolute;
        top: 14px;
        left: 17px;
        background: url("https://lvlin-fe-saas.bj.bcebos.com/guideCard/icon.png") no-repeat center center / 100% 100%;
    }

    .title {
        color: #1e1f24;
        font-family: PingFang SC;
        font-weight: 600;
        font-size: 18px;
        line-height: 18px;
        padding-top: 27px;
        padding-left: 136px;

        span {
            color: #05f;
        }
    }

    .sub-title {
        color: #848691;
        margin-top: 12px;
        padding-left: 136px;
        line-height: 1;
    }

    .btn {
        position: absolute;
        right: 30px;
        top: 30px;
        width: 112px;
        height: 40px;
        border-radius: 6px;
        background: #0055ff1a;
        color: #05f;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 16px;
        line-height: 16px;
    }
}
</style>
